import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    text: "Sagama helped me find my dream home in Abuja! Their team was professional, responsive, and knowledgeable. I highly recommend them to anyone looking for a reliable real estate partner ",
    name: "Mrs. Aisha Mohammed",
    designation: "CEO Amarya Nigeria Limited",
    img: "assets/img/main/testi_1_1.jpg",
  },
  {
    text: "I was impressed by Sagama's expertise and dedication to delivering exceptional results. They helped me sell my property quickly and efficiently. Thank you, Sagama!",
    name: " Mr. Emmanuel Okoro",
    designation: "Business Man",
    img: "assets/img/main/testi_1_2.jpg",
  },
  {
    text: "Sagama's property management services have been a game-changer for me. Their team is proactive, efficient, and always available to address any concerns.",
    name: "Dr.Ngozi Okeke",
    designation: "University Lecturer",
    img: "assets/img/main/testi_1_3.jpg",
  },
  {
    text: "As a first-time buyer, I was nervous about the process, but Sagama's team guided me every step of the way. They were patient, informative, and genuinely interested in helping.",
    name: "Alhaji Abubakar Suleiman",
    designation: "CBN Staff",
    img: "assets/img/main/testi_1_3.jpg",
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="space bg-auto testimonial-bg"
      style={{ position: "relative", isolation: "isolate" }}
    >
      {/* Dark overlay/gradient for readability */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(10,26,61,0.8) 100%)",
          zIndex: 1,
        }}
      />

      <style>{`
        /* Force the testimonial label to white */
        .sub-title6 {
          color: #fff !important;
        }

        .testi-card-new {
          background: #fff;
          border-radius: 20px;
          padding: 35px 25px 30px;  /* extra top padding for badge */
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          position: relative;
          margin: 16px 10px 10px;   /* top margin so badge doesn't clip */
          overflow: visible;        /* ensure badge is not hidden */
          display: flex;
          flex-direction: column;
          height: 100%;
          min-height: 280px;        /* taller card */
        }
        .testi-card-new:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }
        .testi-card-new .verified-badge {
          position: absolute;
          top: -14px;
          right: 20px;
          background: #e86b24;
          color: #fff;
          padding: 5px 14px;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          display: flex;
          align-items: center;
          gap: 4px;
          box-shadow: 0 4px 10px rgba(232,107,36,0.3);
          z-index: 3;
        }
        .testi-card-new .verified-badge i {
          font-size: 0.7rem;
          color: #fff;
        }
        .testi-card-new .testi-text {
          font-size: 0.95rem;
          line-height: 1.7;
          color: #555;
          margin-bottom: 1.5rem;
          font-style: italic;
          flex: 1;                   /* push author to bottom if needed */
        }
        .testi-card-new .author-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: auto;
        }
        .testi-card-new .author-info h4 {
          font-size: 1rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.2rem;
        }
        .testi-card-new .author-info span {
          font-size: 0.85rem;
          color: #888;
        }
        .testi-card-new .stars {
          color: #f59e0b;
          margin-bottom: 0.3rem;
          font-size: 0.9rem;
        }
        .testi-card-new .quote-icon {
          position: absolute;
          bottom: 20px;
          right: 20px;
          opacity: 0.1;
          width: 35px;
        }
      `}</style>

      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            Testimonials
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title text-white">What Our Clients Say?</h2>
        </div>
        <div className="testimonial-slider">
          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div key={index} className="testi-card-new">
                {/* Client Review badge */}
                <div className="verified-badge">
                  <i className="fas fa-star" /> Client Review
                </div>

                <p className="testi-text">“{item.text}”</p>

                <div className="author-row">
                  <div className="author-info">
                    <div className="stars">
                      {"★".repeat(5)}
                    </div>
                    <h4>{item.name}</h4>
                    <span>{item.designation}</span>
                  </div>
                </div>

                <img
                  className="quote-icon"
                  src="assets/img/update1/icon/quote_2.svg"
                  alt="quote"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;